import { Fragment, useState } from 'react';
import {
    useTranslate, Button, useRecordContext,
    useNotify, useRefresh, Confirm,
} from 'react-admin';
import axios from 'axios';
import { makeStyles } from '@mui/styles';
import { LinkOff } from '@material-ui/icons';
import { IconButton, Tooltip, Typography } from '@mui/material';

const useStyles = makeStyles((theme) => ({
    toolbar: {
        display: 'flex',
    },
    spacer: {
        flex: 1,
    },
    buttonMarginLeft: {
        marginLeft: 10
    },
    flexBox: {
        width: 'auto',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center'
    },
    inputMarginLeft: {
        marginLeft: 20
    },
    border: {
        border: '1px solid #6b489d'
    }
}));


const DisAssociateRapToPod = (props) => {
    const classes = useStyles();
    const translate = useTranslate();
    const [open, setOpen] = useState(false);
    const notify = useNotify();
    const refresh = useRefresh();

    const handleConfirm = async (data) => {
        setOpen(false);
        try {
            const options = {
                headers: {},
            };

            const sendData = {
                pod: props.pod
            };

            const token = localStorage.getItem('token');
            options.headers.Authorization = `Bearer ${token}`;

            const res = await axios.post(`/api/v1/rap/disassociate`, sendData, options);
            if (res.status !== 200) {
                notify(translate('app.pods.disassociateRap.errorMessage'), { type: 'error' });
            }
            else {
                notify(translate('app.pods.disassociateRap.successMessage'), { type: 'success' });
                refresh();
            };
        }
        catch (error) {
            if (error.response && error.response.data && error.response.data.message) {
                {
                    error.response.data.detail ? notify(`${error.response.data.message} : ${error.response.data.detail.errorMessage}`, { type: 'error' }) :
                        notify(`${error.response.data.message}`, { type: 'error' })
                };
            }
            else throw new Error(error);
        }
    }

    const handleDialogClose = () => setOpen(false);
    const handleClick = () => {
        setOpen(true);
    };

    return (
        <Fragment>
            {props.showTitle ? (
                <Tooltip title={translate("app.pods.disassociateRap.button")}>
                    <Button
                        onClick={handleClick}
                        size="small"
                        color="primary"
                        startIcon={<LinkOff />}
                        label={translate("app.pods.disassociateRap.button")}
                    >
                    </Button>
                </Tooltip>
            ) : (
                <Tooltip title={translate("app.pods.disassociateRap.button")}>
                    <IconButton
                        onClick={handleClick}
                        size="small"
                        color="primary"
                        aria-label={translate("app.pods.disassociateRap.button")}
                    >
                        <LinkOff />
                    </IconButton>
                </Tooltip>)}
            <Confirm
                isOpen={open}
                title={translate('app.pods.disassociateRap.title')}
                content={translate('app.pods.disassociateRap.message')}
                onConfirm={handleConfirm}
                onClose={handleDialogClose}
            />
        </Fragment>
    );
};

export default DisAssociateRapToPod;

